export default __webpack_public_path__ + "static/benzinga-aba46ffe4d144fddb098cff75422c97c.png";